export default {
  text_input: {
    note: {
      place_holder: 'Notatka...',
    },
  },
  buttons: {
    cancel: 'Anuluj',
    save: 'Zapisz',
  },
};
